import { Route } from '@angular/router';
import { LOGIN_ROUTE } from '@ebanking/features/login/login.routes';
import { authGuard } from '@qvs/core/auth';
import { maintenanceCheckGuard, MaintenancePage, sharedRoutePaths } from '@qvs/shared';
import { appRoutePaths } from '@ebanking/app/app.route-paths';
import { ErrorComponent } from '~/shared/components/error/error.component';

export const ROUTES: Route[] = [
  {
    path: sharedRoutePaths.MAINTENANCE,
    component: MaintenancePage
  },
  {
    path: sharedRoutePaths.ERROR,
    component: ErrorComponent
  },
  { ...LOGIN_ROUTE },
  {
    path: appRoutePaths.PAGES,
    canMatch: [authGuard, maintenanceCheckGuard],
    loadComponent: () => import('@ebanking/app/app-page/app-page.component').then((m) => m.AppPageComponent),
    children: [
      { path: '', redirectTo: appRoutePaths.HOME, pathMatch: 'full' },
      {
        path: appRoutePaths.HOME,
        loadComponent: () => import('@ebanking/features/home/home.page/home.page.component').then((m) => m.HomePageComponent)
      },
      {
        path: appRoutePaths.PORTFOLIOS,
        loadChildren: () => import('@ebanking/features/portfolio/portfolio.routes').then((m) => m.PORTFOLIO_CHILDREN),
        loadComponent: () =>
          import('@ebanking/features/portfolio/portfolio.page/portfolio.page.component').then((m) => m.PortfolioPageComponent)
      },
      {
        path: appRoutePaths.NEWS,
        loadComponent: () => import('@ebanking/features/news/news.page.component').then((m) => m.NewsPageComponent)
      },
      {
        path: appRoutePaths.E_DOCUMENTS,
        loadChildren: () => import('@ebanking/features/e-documents/e-documents.routes').then((m) => m.EDOCUMENTS_CHILDREN),
        loadComponent: () =>
          import('@ebanking/features/portfolio/portfolio.page/portfolio.page.component').then((m) => m.PortfolioPageComponent)
      }
    ]
  },
  { path: '**', redirectTo: `${appRoutePaths.PAGES}/${appRoutePaths.HOME}` }
];
